"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFileField = void 0;
const file_field_1 = require("../../../components/file-field/file-field");
const form_field_1 = require("./form-field");
exports.FormFileField = (0, form_field_1.formFieldFactory)(file_field_1.FileField);
//# sourceMappingURL=form-file-field.js.map